// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/img/banner.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/img/movie.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/img/Poster (3).png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/img/Poster (5).png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./assets/img/Poster (7).png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./assets/img/Poster (8).png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./assets/img/wallpaper.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./assets/img/Frame 1.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./assets/img/Frame 2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("./assets/img/Frame 3.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("./assets/img/Frame 4.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("./assets/img/user.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.homepage_hero_section {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.show_hero_section {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.picture1 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  /* background-size: cover; */
  background-position: center;
}

.picture2 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.picture1 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}


body {
  overflow-x: hidden;
  overflow-y: hidden;
}

html {
  overflow-x: hidden;
}

::-webkit-scrollbar {
  width: 8px; 
}


::-webkit-scrollbar-thumb {
  background-color: #888; 
  border-radius: 4px; 
}

::-webkit-scrollbar-track:hover {
  background-color: #f1f1f1; 
}

::-webkit-scrollbar-thumb:hover {
  background-color: #555; 
}


.sticky {
  position: fixed;
  top: 0;
  width: 100%
}

.notif_sticky {
  position: fixed;
  top: 70px;
  @media screen and (min-width: 470px) {
    top: 90px;
  }
}

.dropdown_sticky {
  position: fixed;
  top: 70px;
  @media screen and (min-width: 470px) {
    top: 90px;
  }
}

.wallpaper {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-repeat: no-repeat;
  background-size: cover;
  background-color: white;
}

.Frame_one{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-repeat: no-repeat;
  background-size: cover;
}

.Frame_two{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-repeat: no-repeat;
  background-size: cover;
}

.Frame_three{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-repeat: no-repeat;
  background-size: cover;
}

.Frame_four{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  background-repeat: no-repeat;
  background-size: cover;
}

.User_img{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  height: 360px;
}

.blue_gradient{
  background: linear-gradient(88.49deg, #0044ff 0.08%, #0044ff 52.89%, #0044ff 106.56%);
  opacity: 0.3;
  filter: blur(95px);
}


.scrolling-pictures {
  display: flex;
  overflow: hidden;
  animation: scroll 20s linear infinite;
}

@keyframes scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-100%);
  }
}

.scrolling-pictures img {
  width: 100%;
  height: auto;
  object-fit: cover;
}

#scroll-image::-webkit-scrollbar {
  display: none;
}

.nonResizableTextarea {
  resize: none;
}

.slider {
  display: flex;
  overflow: hidden;
  width: 100%;
  animation: scroll 10s infinite; /* Adjust the duration as needed */
}

@keyframes scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-100%); /* Assuming horizontal scrolling */
  }
}

.slide {
  flex: 0 0 100%;
  height: 300px; /* Set the height of the slider */
  background-size: cover;
  background-position: center;
}

.scroll-container {
  width: full; /* Adjust as needed */
  overflow-x: auto;
  white-space: nowrap; /* Prevent contents from wrapping */
}

.scroll-containers {
  width: full; /* Adjust as needed */
  overflow-x: auto;

}

.scroll-content {
  display: inline-block; /* Display contents in a row */
  margin-right: 10px;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,yDAA8C;EAC9C,4BAA4B;EAC5B,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,yDAA6C;EAC7C,4BAA4B;EAC5B,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,yDAAqD;EACrD,4BAA4B;EAC5B,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,yDAAqD;EACrD,4BAA4B;EAC5B,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,yDAAqD;EAOrD,yDAAqD;EACrD,4BAA4B;EAC5B,sBAAsB;EACtB,2BAA2B;AAN7B;;;AAUA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;;AAGA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;;AAGA;EACE,eAAe;EACf,MAAM;EACN;AACF;;AAEA;EACE,eAAe;EACf,SAAS;EACT;IACE,SAAS;EACX;AACF;;AAEA;EACE,eAAe;EACf,SAAS;EACT;IACE,SAAS;EACX;AACF;;AAEA;EACE,yDAAiD;EACjD,4BAA4B;EAC5B,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,yDAAgD;EAChD,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,yDAAgD;EAChD,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,yDAAgD;EAChD,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,0DAAgD;EAChD,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,0DAA4C;EAC5C,4BAA4B;EAC5B,sBAAsB;EACtB,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,qFAAqF;EACrF,YAAY;EACZ,kBAAkB;AACpB;;;AAGA;EACE,aAAa;EACb,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,8BAA8B,EAAE,kCAAkC;AACpE;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B,EAAE,kCAAkC;EAClE;AACF;;AAEA;EACE,cAAc;EACd,aAAa,EAAE,iCAAiC;EAChD,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,WAAW,EAAE,qBAAqB;EAClC,gBAAgB;EAChB,mBAAmB,EAAE,mCAAmC;AAC1D;;AAEA;EACE,WAAW,EAAE,qBAAqB;EAClC,gBAAgB;;AAElB;;AAEA;EACE,qBAAqB,EAAE,8BAA8B;EACrD,kBAAkB;AACpB","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.homepage_hero_section {\n  background-image: url(./assets/img/banner.png);\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n}\n\n.show_hero_section {\n  background-image: url(./assets/img/movie.png);\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n}\n\n.picture1 {\n  background-image: url(./assets/img/Poster\\ \\(3\\).png);\n  background-repeat: no-repeat;\n  /* background-size: cover; */\n  background-position: center;\n}\n\n.picture2 {\n  background-image: url(./assets/img/Poster\\ \\(5\\).png);\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n}\n\n.picture1 {\n  background-image: url(./assets/img/Poster\\ \\(7\\).png);\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n}\n\n.picture1 {\n  background-image: url(./assets/img/Poster\\ \\(8\\).png);\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n}\n\n\nbody {\n  overflow-x: hidden;\n  overflow-y: hidden;\n}\n\nhtml {\n  overflow-x: hidden;\n}\n\n::-webkit-scrollbar {\n  width: 8px; \n}\n\n\n::-webkit-scrollbar-thumb {\n  background-color: #888; \n  border-radius: 4px; \n}\n\n::-webkit-scrollbar-track:hover {\n  background-color: #f1f1f1; \n}\n\n::-webkit-scrollbar-thumb:hover {\n  background-color: #555; \n}\n\n\n.sticky {\n  position: fixed;\n  top: 0;\n  width: 100%\n}\n\n.notif_sticky {\n  position: fixed;\n  top: 70px;\n  @media screen and (min-width: 470px) {\n    top: 90px;\n  }\n}\n\n.dropdown_sticky {\n  position: fixed;\n  top: 70px;\n  @media screen and (min-width: 470px) {\n    top: 90px;\n  }\n}\n\n.wallpaper {\n  background-image: url(./assets/img/wallpaper.png);\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-color: white;\n}\n\n.Frame_one{\n  background-image: url(./assets/img/Frame\\ 1.png);\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n\n.Frame_two{\n  background-image: url(./assets/img/Frame\\ 2.png);\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n\n.Frame_three{\n  background-image: url(./assets/img/Frame\\ 3.png);\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n\n.Frame_four{\n  background-image: url(./assets/img/Frame\\ 4.png);\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n\n.User_img{\n  background-image: url(./assets/img/user.png);\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n  height: 360px;\n}\n\n.blue_gradient{\n  background: linear-gradient(88.49deg, #0044ff 0.08%, #0044ff 52.89%, #0044ff 106.56%);\n  opacity: 0.3;\n  filter: blur(95px);\n}\n\n\n.scrolling-pictures {\n  display: flex;\n  overflow: hidden;\n  animation: scroll 20s linear infinite;\n}\n\n@keyframes scroll {\n  0% {\n    transform: translateX(0);\n  }\n  100% {\n    transform: translateX(-100%);\n  }\n}\n\n.scrolling-pictures img {\n  width: 100%;\n  height: auto;\n  object-fit: cover;\n}\n\n#scroll-image::-webkit-scrollbar {\n  display: none;\n}\n\n.nonResizableTextarea {\n  resize: none;\n}\n\n.slider {\n  display: flex;\n  overflow: hidden;\n  width: 100%;\n  animation: scroll 10s infinite; /* Adjust the duration as needed */\n}\n\n@keyframes scroll {\n  0% {\n    transform: translateX(0);\n  }\n  100% {\n    transform: translateX(-100%); /* Assuming horizontal scrolling */\n  }\n}\n\n.slide {\n  flex: 0 0 100%;\n  height: 300px; /* Set the height of the slider */\n  background-size: cover;\n  background-position: center;\n}\n\n.scroll-container {\n  width: full; /* Adjust as needed */\n  overflow-x: auto;\n  white-space: nowrap; /* Prevent contents from wrapping */\n}\n\n.scroll-containers {\n  width: full; /* Adjust as needed */\n  overflow-x: auto;\n\n}\n\n.scroll-content {\n  display: inline-block; /* Display contents in a row */\n  margin-right: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
